
import { createSlice } from '@reduxjs/toolkit';
import {
  TeamMembersListState,
  TeamMembersListFetchAction,
  TeamMembersListFetchSuccessAction,
  TeamMembersListDeleteAction,
  TeamMembersListDeleteSuccessAction,
  TeamMembersListAllFetchAction,
  TeamMembersListAllFetchSuccessAction,
} from './teamMembersList.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: TeamMembersListState = {
  loading: false,
  error: undefined,
  data: undefined,
  allData: undefined,
};

const { actResolve, actReject, actReq } =
  makeActionCreator<TeamMembersListState>();

export const teamMembersListSlice = createSlice({
  name: 'teamMembersList',
  initialState,
  reducers: {
    fetchTeamMembersList: actReq<TeamMembersListFetchAction['payload']>(),
    fetchTeamMembersListSuccess:
      actResolve<TeamMembersListFetchSuccessAction['payload']>(),
    fetchTeamMembersListFailure: actReject(),
    fetchTeamMembersListAll:
      actReq<TeamMembersListAllFetchAction['payload']>(),
    fetchTeamMembersListAllSuccess:
      actResolve<TeamMembersListAllFetchSuccessAction['payload']>('allData'),
    fetchTeamMembersListAllFailure: actReject(),
    deleteTeamMember: actReq<TeamMembersListDeleteAction['payload']>(),
    deleteTeamMemberSuccess:
      actResolve<TeamMembersListDeleteSuccessAction['payload']>(null),
    deleteTeamMemberFailure: actReject(),
  },
});

export const {
  fetchTeamMembersList,
  deleteTeamMember,
  deleteTeamMemberSuccess,
  deleteTeamMemberFailure,
} = teamMembersListSlice.actions;

export const actions = {
  ...teamMembersListSlice.actions,
};

export const useTeamMembersListSlice = createSliceHook(
  teamMembersListSlice.name,
  actions
);
